// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"276":"b73b8d10f3be8435","5875":"dd5484312af145fa"}[chunkId] + ".js";
};